import { differenceInDays } from 'date-fns';

import {
    CoachingTranscript,
    EventResult,
    FocusContainerDto,
    InteractionDto,
    ObservationDto,
} from '../../../coaching-base/general';
import { NoteDetailFormValue } from '../../../coaching-note/note-detail-form-value.model';

export function createObservationOverride(
    transcript: CoachingTranscript,
    notes: NoteDetailFormValue[],
): ObservationDto {
    // const interaction = createInteraction();
    // interaction.time = new Date(this.state?.transcript?.createdOn);
    // interaction.date = new Date(this.state?.transcript?.createdOn);
    // interaction.notes = this._form.value.map(e => {
    //     const note = createNoteDetail(e.category);
    //     note.contents = e.contents;
    //     return note;
    // });
    //
    // const fc = createFocusContainer();
    // fc.interactions = [interaction];

    // check if transcript is over 30 days
    const now = new Date();
    const days = differenceInDays(transcript.createdOn, now);
    const obsStartDate = 30 + days < 0 ? now : transcript.createdOn;

    const interaction: InteractionDto = {
        createdBy: undefined,
        createdOn: undefined,
        interactionDateTime: obsStartDate,
        interactionId: undefined,
        interactionIdentifier: undefined,
        interactionTypeId: undefined,
        interactionPurposeId: undefined,
        notes: notes.map((e) => ({
            noteId: e.noteId,
            noteCategoryId: e.category,
            contents: e.contents,
            createdBy: undefined,
            createdOn: undefined,
            published: undefined,
            publishedOn: undefined,
        })),
        observerId: undefined,
        performerId: undefined,
        queueId: undefined,
        scoring: undefined,
        updatedBy: undefined,
        updatedOn: undefined,
    };

    const transcriptFocus =
        transcript.focuses?.find((e) => e.isPrimary === true) ??
        transcript.focuses?.find((e) => e.isPrimary !== true);
    const fc: FocusContainerDto = {
        behaviourId: transcriptFocus?.behaviourId,
        focusId: undefined,
        interactions: [interaction],
        metrics: undefined,
        subBehaviourId: transcriptFocus?.subBehaviourId,
    };

    const event: EventResult = {
        createdBy: undefined,
        createdOn: undefined,
        deleted: undefined,
        deliveryTypeFullName: undefined,
        deliveryTypeId: undefined,
        deliveryTypeInitials: undefined,
        deliveryTypeShortName: undefined,
        duration: Math.max(
            1,
            Math.ceil(
                (transcript.quotes.at(-1)?.endTime?.getTime() -
                    transcript.quotes[0]?.endTime?.getTime()) /
                    1000 /
                    60,
            ),
        ),
        endTime: undefined,
        eventId: undefined,
        eventTypeFullName: undefined,
        eventTypeId: undefined,
        eventTypeInitials: undefined,
        eventTypeShortName: undefined,
        published: undefined,
        sessionDate: undefined,
        shareWithPerformer: undefined,
        startTime: obsStartDate,
        updatedBy: undefined,
        updatedOn: undefined,
    };

    return {
        event,
        eventParticipants: undefined,
        focusContainers: [fc],
    };
}
